import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { useFormContext } from "react-hook-form";
// import { useProfileImage } from "../../../store/state";
import Avatar from "@material-ui/core/Avatar";
import { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(1),
      width: theme.spacing(16),
      height: theme.spacing(16),
    },
  },
  preview: {
    display: "flex",
    flexDirection: "column",
    padding: 30,
    justifyContent: "center",
    alignItems: "center",
    margin: "0px 30px 0px 30px",
    alignSelf: "center",
  },
  mainProfile: {
    maxheight: "80%",
    width: "80%",
    maxWidth: 300,
    alignSelf: "center",
    marginTop: 120,
  },
  avatarWrapper: {
    marginTop: -90,
    display: "flex",
    justifyContent: "center",
  },
  avatar: {
    height: 120,
    width: 120,
    boxShadow: "1px 1px 50px 3px rgba(0,0,0,0.36)",
  },
  firstRow: {
    display: "flex",
    justifyContent: "space-around",
  },
  buttonRow: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: 30,
  },
  uploadButton: {
    margin: 30,
    alignSelf: "center",
    justifyContent: "center",
    display: "flex",
  },
}));

export default function Preview(props) {
  const classes = useStyles();
  const { watch } = useFormContext();
  const data = watch(); 
  const { file, fileHandler } = props;


  return (
    <Paper className={classes.preview}>
      <h2 className="fw-bold mb-3">
        Profile Preview
      </h2>
      <div className={classes.mainProfile}>
        <div className={classes.avatarWrapper}>
          {file ? (
            <Avatar
              className={classes.avatar}
              alt={`${data.firstName} ${data.lastName}`}
              src={URL.createObjectURL(file)}
            />
          ) : (
            <Avatar className={classes.avatar} />
          )}
        </div>
        <div className={classes.uploadButton}>
          <Button variant="contained" component="label">
            Upload Image
            <input
              type="file"
              onChange={(e) => fileHandler(e.target.files[0])}
              hidden
            />
          </Button>
        </div>

        <h1 style={{textAlign:'center'}}>
          {data.firstName} {data.lastName}
        </h1>
        <div className={classes.bio}>
          <p>{data.description}</p>
        </div>

      </div>
    </Paper>
  );
}
